const DEFAULT_UNKNOWN_WORD_SORT_BY = 'APPEARANCE'

export default DEFAULT_UNKNOWN_WORD_SORT_BY
